import { ModalState } from './definitions';

export class ModalFactory 
{
	public static build(): ModalState 
	{
		return {
			hidden: true,
			label: '',
			buttons: [],
			cssClass: '',
			closeHidden: false,
			tooltip: {
				closeIcon: {
					iconPath: '',
					altText: ''
				},
				content: ''
			}
		};
	}
}
